const svdBaseURL = process.env.VUE_APP_SVD_API_URL
const contentDeliveryBaseURL = process.env.VUE_APP_CONTENT_DELIVERY_API_URL
const backofficeURL = process.env.VUE_APP_BACKOFFICE_API_URL
const urlDeviceMonitoringApi = process.env.VUE_APP_DEVICE_MONITORING_API_URL
const auditTrailURL = process.env.VUE_APP_AUDIT_TRAIL_URL

export const url = {
    content_delivery_url: contentDeliveryBaseURL,
    svd: {
        auth: {
            login: svdBaseURL + "api/v1/auth/login",
            refresh_token: svdBaseURL + "api/v1/auth/refresh_token",
            logout: svdBaseURL + "api/v1/auth/logout",
            // hide register
            // register: svdBaseURL + "api/v1/register",
            me: svdBaseURL + "api/v1/auth/me",
            validatesession: svdBaseURL + "api/v1/auth/validatesession",
        },
        sso: {
            authorize: svdBaseURL + "api/v1/sso/authorize"
        },
        merchant: {
            categories: svdBaseURL + "api/v1/merchant-categories/list",
            save: svdBaseURL + "api/v1/merchants",
            account_info: svdBaseURL + "api/v1/merchants",
            request_verification: svdBaseURL + "api/v1/merchants-verification/request",
            getSubmerchants: svdBaseURL + "api/v1/submerchants",
            merchant_user: svdBaseURL + "api/v1/merchants/user",
            detail: svdBaseURL + "api/v1/merchants",
            list: svdBaseURL + "api/v1/merchants/list",
            list_by_parent_id: svdBaseURL + "api/v1/merchants/list",
            combo: svdBaseURL + "api/v1/merchants-combo",
            tree: svdBaseURL + "api/v1/merchants-tree",
            update_tree: svdBaseURL + "api/v1/merchants-tree",
            setStatus: svdBaseURL + "api/v1/merchants/status",
            comboSubMerchant: svdBaseURL + "api/v1/submerchants-combo",
        },
        location_mapping: {
            list: svdBaseURL + "api/v1/location-mapping",
            store: svdBaseURL + "api/v1/location-mapping",
            update: svdBaseURL + "api/v1/location-mapping",
            storeBulk: svdBaseURL + "api/v1/bulk-location-mapping"
        },
        svd_location_mapping: {
            list: svdBaseURL + "api/v1/svd-location-mapping",
            store: svdBaseURL + "api/v1/svd-location-mapping",
            update: svdBaseURL + "api/v1/svd-location-mapping/",
            storeBulk: svdBaseURL + "api/v1/bulk-svd-location-mapping"
        },
        service: {
            info: svdBaseURL + "api/v1/services"
        },
        device_mapping: {
            list: svdBaseURL + "api/v1/device-mapping",
            store: svdBaseURL + "api/v1/device-mapping",
            update: svdBaseURL + "api/v1/device-mapping",
            storeBulk: svdBaseURL + "api/v1/bulk-device-mapping"
        },
        device_setup: {
            list: svdBaseURL + "api/v1/merchant-device-setup",
            update: svdBaseURL + "api/v1/merchant-device-setup",
            file: svdBaseURL + "api/v1/merchant-device-setup/file",
            file_download: svdBaseURL + "api/v1/merchant-device-setup/file/download"
        },
        device_request: {
            update: svdBaseURL + "api/v1/merchant-device-request",
            store: svdBaseURL + "api/v1/merchant-device-request",
            list: svdBaseURL + "api/v1/merchant-device-request",
            detail: svdBaseURL + "api/v1/merchant-device-request",
            detailById: svdBaseURL + "api/v1/merchant-device-request-detail"
        },
        device_request_new: {
            store: svdBaseURL + "api/v1/device-request",
            list: svdBaseURL + "api/v1/device-request",
            update_serial_number: svdBaseURL + "api/v1/device-request-serial-number",
            delete: svdBaseURL + "api/v1/delete-device-request"
        },
        device_request_detail: {
            update: svdBaseURL + "api/v1/merchant-device-assignments/detail"
        },
        device_assignment: {
            update: svdBaseURL + "api/v1/merchant-device-assignments",
            detail: svdBaseURL + "api/v1/merchant-device-assignments/detail",
            unpair: svdBaseURL + "api/v1/devices/provision",
            detail_device: svdBaseURL + "api/v1/merchant-device-assignments/detail",
        },
        payment_channel: {
            list_selection: svdBaseURL + "api/v1/payment-channels/list",
            general_config: svdBaseURL + "api/v1/payment-channels/general-config",
            combo: backofficeURL + "api/v1/payment-channels-combo",
        },
        device: {
            store: svdBaseURL + "api/v1/devices",
            detail: svdBaseURL + "api/v1/devices",
            list: svdBaseURL + "api/v1/devices",
            combo: svdBaseURL + "api/v1/devices/list",
            report: svdBaseURL + "api/v1/devices-report",
            delete: svdBaseURL + "api/v1/devices",
            import_excel: svdBaseURL + "api/v1/devices-import",
            unpair: svdBaseURL + "api/v1/devices/provision",
            listProvisioned: svdBaseURL + "api/v1/devices-list-provisioned"
        },
        mid: {
            store: svdBaseURL + "api/v1/mid",
            update: svdBaseURL + "api/v1/mid/",
            bulkStore: svdBaseURL + "api/v1/bulk-store-mid",
        },
        tid: {
            store: svdBaseURL + "api/v1/tid",
            update: svdBaseURL + "api/v1/tid/",
            bulkStore: svdBaseURL + "api/v1/bulk-store-tid",
        },
        device_type: {
            store: svdBaseURL + "api/v1/device-types",
            list: svdBaseURL + "api/v1/device-types",
            detail: svdBaseURL + "api/v1/device-types",
            update: svdBaseURL + "api/v1/device-types",
            delete: svdBaseURL + "api/v1/device-types",
            selection: svdBaseURL + "api/v1/device-types/list",
        },
        menu: {
            list: svdBaseURL + "api/v1/menus"
        },
        user: {
            list: svdBaseURL + "api/v1/users",
            register: svdBaseURL + "api/v1/user/register",
            detail: svdBaseURL + "api/v1/user/",
            update: svdBaseURL + "api/v1/user/update/",
            activation: svdBaseURL + "api/v1/user/activation/",
        },
        roles: {
            list: svdBaseURL + "api/v1/roles",
        },
        shiftdate: {
            new: svdBaseURL + "api/v1/shiftdate",
            list: svdBaseURL + "api/v1/shiftdate",
            update: svdBaseURL + "api/v1/shiftdate",
            delete: svdBaseURL + "api/v1/shiftdate",
        }
    },
    backoffice: {
        issuer: {
            list: backofficeURL + "api/v1/issuers/list"
        }
    },
    content_delivery: {
        base: contentDeliveryBaseURL,
        upload: contentDeliveryBaseURL + "api/v1/files/upload",
        download: contentDeliveryBaseURL + "api/v1/files/download"
    },
    device_monitoring: {
        list: urlDeviceMonitoringApi + "device/v1/status/filter",
        filter: urlDeviceMonitoringApi + "device/v1/status/filter",
        detail: urlDeviceMonitoringApi + "device/v1/status",
        device_dashboard: urlDeviceMonitoringApi + "device/v1/status/dashboard"
    },
    device_remote: {
        publish: urlDeviceMonitoringApi + "device/v1/remote/publish"
    },
    device_trxn_summary: {
        list: urlDeviceMonitoringApi + "device/v1/summary/transactions",
        filter: urlDeviceMonitoringApi + "device/v1/summary/transactions",
        detail: urlDeviceMonitoringApi + "device/v1/summary/transaction",
        dashboard: urlDeviceMonitoringApi + "device/v1/summary/dashboard"
    },
    device_event: {
        list: urlDeviceMonitoringApi + "device/v1/event/filter"
    },
    device_update: {
        publish: urlDeviceMonitoringApi + "device/v1/update/publish"
    },
    audit_trail: {
        save_device_remote_activity: auditTrailURL + "v1/device/remote-activity",
        get_device_remote_activities: auditTrailURL + "v1/device/remote-activities",
        log_activity_user: auditTrailURL + "api/v1/user-log-activity/activities",
        save_user_log_activity: auditTrailURL + "api/v1/user-log-activity/activity"
    }
}
